export const ExtraProtectionData = [
  {
    id: 2,
    title: "Temporanea caso morte accidentale (ACMA-IS)",
    code: "ACMA-IS",
    multiplier: "0.005",
    disabled: false,
    svgClass: "cop-acma",
    listValues: [
      10000,
      20000,
      30000,
      40000,
      50000,
      60000,
      70000,
      80000,
      90000,
      100000
    ],
    model: {
      selected: false,
      value: 0
    }
  }
];
